import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { BlogtagService } from 'api/blogtag/blogtag.service';
import { ApiConstant } from 'api/api.constant';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'application-page',
    templateUrl: './blogpostdetail.html',
})
export class Blogpostdetail implements OnInit {
    pstatus: boolean = true
    searchvalue: String;
    id: any;
    imageid: any
    file: File
    imagename: string
    blogimage = []
    index: number
    iname: any;
    blogdata = []
    title: any
    url: any
    category: any
    athumbnails: File = null
    athumbnails1: File
    sortdescription: any
    description: any
    imageurl: any
    status = "SAVEDRAFT"
    alltag = [];
    alltag1 = []
    selectedtag1 = []
    versionincrement = 0.1
    a: number;
    profilepic: any
    banner: File = null
    blogurl: any
    bid: any;
    version: any
    categoryId: any
    constructor(private router: Router,
        private blogpostdetailservice: BlogPostdetailsService,
        private blogpostService: BlogpostService,
        private blogtagService: BlogtagService,
        private activatedroute: ActivatedRoute,
        private apiconstant: ApiConstant) {
    }
    ngOnInit() {
        this.blogurl = this.apiconstant.blogurl
        this.imageurl = this.apiconstant.blogimageurl
        const params = this.activatedroute.snapshot.params;
        this.id = params.id
        this.bid = params.bid
        $(function () {
            $('.select4').select2();
            $('.select4-tags').select2({
                tags: true,
                tokenSeparators: [',', ' ']
            });
            $('.selectpicker').selectpicker();
        });
        $(function () {
            $('.summernote').summernote({
                height: 50
            });
        });
        $(function () {
            $('.summernote1').summernote({
                height: 500
            });
        });
        this.initdata()
    }
    initdata() {
        this.blogtagService.allBlogTag().then(data => {
            if (data) {
                this.alltag = data
                this.blogpostService.allBlogpost(this.bid).then(data => {
                    if (data) {
                        this.blogdata = data
                        this.title = this.blogdata[0]['title']
                        this.category = this.blogdata[0]['name']
                        this.categoryId = this.blogdata[0]['categoryId']
                        this.url = this.blogdata[0]['url']
                        this.sortdescription = this.blogdata[0]['sortdescription']
                        $(".summernote").summernote("code", this.blogdata[0]['sortdescription']);
                        this.description = this.blogdata[0]['description']
                        if (this.description != null) {
                            $(".summernote1").summernote("code", this.blogdata[0]['description']);
                        }
                        this.athumbnails = this.blogdata[0]['articlethumbnails']
                        var str = this.blogdata[0]['tagId'];
                        if (str != undefined) {
                            var arr = str.split(",");
                            var tagarr = [];
                            for (var j = 0; j < this.alltag.length; j++) {
                                tagarr[j] = this.alltag[j].id;
                            }
                            var tagarray = tagarr.map(String);
                            const intersection = arr.filter(element => tagarray.includes(element));
                            var inttagarray = intersection.map(Number);
                            this.selectedtag1 = []
                            if (inttagarray.length > 0) {
                                $(".select4-tags").select2({
                                    tags: true,
                                    tokenSeparators: [',', ' ']
                                }).val(inttagarray).trigger("change");
                            } else {
                                $(".select4-tags").select2({
                                    tags: true,
                                    tokenSeparators: [',', ' ']
                                }).val(null).trigger("change");
                            }
                        }
                        this.status = this.blogdata[0]['status']
                        this.version = this.blogdata[0]['version']
                        if (this.version == null) {
                            this.version = 1.0
                        }
                        if (this.status == 'LIVE' || this.status == 'OFFLINE') {
                            this.version = (this.version + this.versionincrement).toFixed(1)
                            this.blogsave1();
                        } else {
                            var data2 = {
                                version: this.version
                            }
                            this.blogpostdetailservice.allimage(data2, this.bid).then(data => {
                                this.blogimage = data
                            })
                        }
                    }
                });
            }
        })
    }
    resetData() {
        $('#mySelect4').val(null).trigger("change");
        this.athumbnails = null
        this.athumbnails1 = undefined
        this.sortdescription = null
        this.description = null
        $(".summernote1").summernote("code", "");
        $(".summernote").summernote("code", "");
    }
    Previewblog(url, version, id) {
        this.blogurl = this.apiconstant.blogurl
        var finalurl = (this.blogurl + url + '/' + id + '?version=' + version)
        window.open(finalurl, "_blank");
    }
    createFormData1(event) {
        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;
                if (width == 730 && height == 341) {
                    this.athumbnails1 = <File>event.target.files[0];
                }
                else {
                    $("#fileInputId").val(null);
                    alert('Height and Width must  exceed 730*341 pixels.')
                }
            };
        };
        fr.readAsDataURL(file)
    }
    createFormData(event) {
        this.file = <File>event.target.files[0];
        var type = <File>event.target.files[0].type;
        this.imagename = this.file.name.toString()
        var data = {
            name: this.imagename,
            version: this.version
        }
        this.blogpostdetailservice.Uploadimage(data, this.file, this.bid).then(data => {
            if (data) {
                this.blogimage.push(data.data)
            }
        })
    }
    blogsave1() {
        this.sortdescription = $('.summernote').summernote('code');
        this.description = $('.summernote1').summernote('code');
        var array = $('#mySelect4').select2('data');
        var selectedtext = []
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            selectedtext.push(element.text.trim())
        }
        if (selectedtext.length == 0 || selectedtext == null) {
            alert("Please Enter Atleast One Tag")
            return;
        }
        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: selectedtext.toString(),
            version: this.version,
            category: this.categoryId,
            status: "SAVEDRAFT",
            articlethumbnails: this.athumbnails
        }
        this.blogpostdetailservice.iblogpost1(data, this.banner, this.bid).then(data => {
            this.blogimage = data.image
        })
    }
    blogsave() {
        this.sortdescription = $('.summernote').summernote('code');
        this.description = $('.summernote1').summernote('code');
        var array = $('#mySelect4').select2('data');
        var selectedtext = []
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            selectedtext.push(element.text.trim())
        }
        if (selectedtext.length == 0 || selectedtext == null) {
            alert("Please Enter Atleast One Tag")
            return;
        }
        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: selectedtext.toString(),
            version: this.version,
            category: this.categoryId,
            status: "SAVEDRAFT",
            articlethumbnails: this.athumbnails
        }
        this.blogpostdetailservice.iblogpost(data, this.athumbnails1, this.bid).then(data => {
            if (data.status) {
                this.initdata()
                $.notify({
                    message: "Blog status SaveDraft"
                }, {
                    type: 'success',
                    placement: {
                        from: 'top',
                        align: 'center'
                    },
                    delay: 100,
                    timer: 100
                });
                return;
            }
        })
    }
    blogpublish() {
        this.sortdescription = $('.summernote').summernote('code');
        this.description = $('.summernote1').summernote('code');
        var array = $('#mySelect4').select2('data');
        var selectedtext = []
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            selectedtext.push(element.text.trim())
        }
        if (this.title == undefined || this.title == "") {
            $.notify({
                message: "Please Enter title."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.url == undefined || this.url == "") {
            $.notify({
                message: "Please Enter url."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return
        }
        if (selectedtext == undefined || selectedtext == [] || selectedtext.length == 0) {
            $.notify({
                message: "Please Enter tagitems ."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.sortdescription == undefined || this.sortdescription == null || this.sortdescription == "") {
            $.notify({
                message: "Please Enter sortdescription ."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.description == undefined || this.description == null || this.description == "") {
            $.notify({
                message: "Please Enter description ."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.athumbnails == undefined || this.athumbnails == null) {
            {
                if (this.athumbnails1 == undefined || this.athumbnails1 == null) {
                    $.notify({
                        message: "Please Select Article Thumbnails."
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    return;
                }
            }
        }
        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: selectedtext.toString(),
            version: this.version,
            category: this.categoryId,
            status: "PENDDING",
            articlethumbnails: this.athumbnails
        }
        this.blogpostdetailservice.iblogpost(data, this.athumbnails1, this.bid).then(data => {
            if (data.status) {
                this.initdata()
                $.notify({
                    message: "Blog status Pendding"
                }, {
                    type: 'success',
                    placement: {
                        from: 'top',
                        align: 'center'
                    },
                    delay: 100,
                    timer: 100
                });
                return;
            }
        })
    }
    updateList(i: number, property: string, event: any) {
        const editField = event.target.textContent;
        this.blogimage[i][property] = editField
        this.imagename = this.blogimage[i][property]
    }
    Preview(url) {
        var finalurl = this.imageurl + url
        window.open(finalurl, "_blank");
    }
    deleteimage(image, index) {
        this.imageid = image.id
        var data = {
            version: image.version
        }
        this.index = index
        this.blogpostdetailservice.dblogimage(data, this.imageid).then(data => {
            if (data.status) {
                this.blogimage.splice(this.index, 1);
            }
        })
    }
    updateimagename(i, index) {
        var id = i.id
        var iversion = i.version
        var data = {
            imagename: this.imagename,
            version: iversion
        }
        this.blogpostdetailservice.Updateimage(data, id).then(data => {
            if (data.status) {
                this.blogimage[index] = data.data
            }
        })
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/blogpostdetail/blogpostdetail.page.ts